import VideoWidgetView from './VideoWidgetView.vue';
import VideoWidgetEditor from './VideoWidgetEditor.vue';

export const type = 'video';
export const view = VideoWidgetView;
export const editor = VideoWidgetEditor;

export function builder() {
  return {
    type,
    url: 'https://video.wixstatic.com/video/dcff78_00f290ce695249e68f01ef332c6784ea/720p/mp4/file.mp4',
    showMuteButton: false,
    left: 0,
    top: 0,
    rotate: 0,
    height: 100,
    width: 350,
  };
}
